import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export function RequireAuth() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50">
        <div className="w-8 h-8 border-4 border-brand-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // The POS is dealer-only; a non-dealer should never reach a POS route.
  if (user.tier !== 'dealer') {
    return <Navigate to="/login" replace />;
  }

  if (user.mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  // Dealer users who haven't completed setup are redirected to the wizard
  if (
    user.tier === 'dealer' &&
    !user.mustChangePassword &&
    user.setupComplete === false &&
    location.pathname !== '/setup'
  ) {
    return <Navigate to="/setup" replace />;
  }

  return <Outlet />;
}
